import { EnvironmentProviders } from "@angular/core";

import { provideUnleashContextSyncInitializer } from "./initializers/unleash-context-sync.initializer";
import { provideUnleashProxyInitializer } from "./initializers/unleash-proxy.initializer";
import { provideUnleashConfig } from "./providers/unleash-config.provider";

export const provideFeatureFlags = (): EnvironmentProviders[] => {
  return [
    provideUnleashConfig(),
    provideUnleashProxyInitializer(),
    provideUnleashContextSyncInitializer(),
  ];
};
